'use client';

import dynamic from 'next/dynamic';

export const MobileTradeModal = dynamic(
  () => import('./MobileTradeModal').then((mod) => mod.MobileTradeModal),
  { ssr: false }
);
